import { Link } from "react-router-dom";

export default function FinalCTA() {
  return (
    <section className="relative w-full py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20peaceful%20restful%20bedroom%20corner%20with%20soft%20morning%20light%20filtering%20through%20sheer%20linen%20curtains%2C%20a%20neatly%20made%20bed%20with%20cream%20and%20beige%20bedding%2C%20a%20small%20wooden%20bedside%20table%20with%20a%20glass%20of%20water%20and%20a%20simple%20ceramic%20vase%20with%20dried%20eucalyptus%2C%20calm%20sanctuary%20like%20atmosphere%2C%20warm%20neutral%20tones%2C%20premium%20interior%20photography%2C%20quiet%20and%20restorative%20mood&width=1600&height=800&seq=final-cta-home-2026&orientation=landscape"
          alt="A peaceful restful bedroom corner with soft morning light, cream bedding, and dried eucalyptus, calm sanctuary atmosphere"
          title="Serena's Quiet Recovery Space - Private Recovery Support"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-background-50 mb-6">
            You only need to take one small step
          </h2>

          <p className="font-body text-sm md:text-base text-background-200 leading-relaxed mb-4">
            If you are ready for private, gentle support to help you change your relationship with alcohol, Quiet Recovery Space is here to help.
          </p>

          <p className="font-body text-sm md:text-base text-background-300 leading-relaxed mb-10">
            You do not need to have everything figured out. You only need a place to begin.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://calendly.com/sraimes43/30min"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-block bg-accent-500 text-background-50 font-body text-sm font-medium px-8 py-3 rounded-md hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book a Quiet Conversation
            </a>
            <Link
              to="/contact"
              className="inline-block font-body text-sm text-background-100 hover:text-background-50 transition-colors duration-300 underline underline-offset-4"
            >
              Or get in touch to ask a question
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}